var _path, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDistroColorido(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.23 7.297a9.167 9.167 0 1 0 0 18.334 9.167 9.167 0 0 0 0-18.334Zm0 16.5a7.333 7.333 0 1 1 0-14.667 7.333 7.333 0 0 1 0 14.667Zm0-10.084a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5Zm0 3.667a.917.917 0 1 1 0-1.834.917.917 0 0 1 0 1.834Z",
    fill: "#F2F2F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.465,
    r: 15.273,
    stroke: "url(#1234alfa)",
    strokeWidth: 1.455,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "1234alfa",
    x1: 34.449,
    y1: 33.424,
    x2: 0,
    y2: 33.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E64B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#F3795E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#E4BC5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#39D68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682,
    stopColor: "#37B1E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#874FC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05576"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDistroColorido);
export default __webpack_public_path__ + "static/media/icon-distro-colorido.83092edf8362672ab37088505777f286.svg";
export { ForwardRef as ReactComponent };